/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { Column } from '../../layout/components/dom'
import Filters from './Filters'
import FeaturedPosts from './FeaturedPosts'
import PostsList from './PostsList'
import { Helmet } from 'react-helmet'

function Blog() {


    return <Column style={{ alignItems: 'center' }}>
        <Helmet>
            <title>Blog - Gateway Forge</title>
            <meta name="description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />
            <meta property="og:url" content="https://gatewayforge.com/blog" />
            <meta property="og:title" content="Blog - Gateway Forge" />
            <meta property="og:description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />

        </Helmet>

        <FeaturedPosts />
        <Filters />
        <PostsList />
    </Column>
};













export default Blog